export default {"src":"/_next/static/media/pause-sip.6ede2f11.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};